/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Interview_TitleInputs */

const en_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Prep`)
};

const de_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch-Vorbereitung`)
};

const fr_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'entretien`)
};

const es_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación de entrevista`)
};

const it_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione al colloquio`)
};

const nl_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegespreksvoorbereiding`)
};

const pl_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy kwalifikacyjnej`)
};

const fi_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastatteluun valmistautuminen`)
};

const da_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse`)
};

const sv_landing_feature_interview_title = /** @type {(inputs: Landing_Feature_Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuförberedelse`)
};

/**
* | output |
* | --- |
* | "Interview Prep" |
*
* @param {Landing_Feature_Interview_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_interview_title = /** @type {((inputs?: Landing_Feature_Interview_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Interview_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_interview_title(inputs)
	if (locale === "fr") return fr_landing_feature_interview_title(inputs)
	if (locale === "es") return es_landing_feature_interview_title(inputs)
	if (locale === "it") return it_landing_feature_interview_title(inputs)
	if (locale === "nl") return nl_landing_feature_interview_title(inputs)
	if (locale === "pl") return pl_landing_feature_interview_title(inputs)
	if (locale === "fi") return fi_landing_feature_interview_title(inputs)
	if (locale === "da") return da_landing_feature_interview_title(inputs)
	if (locale === "sv") return sv_landing_feature_interview_title(inputs)
	return en_landing_feature_interview_title(inputs)
});